import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as echarts from 'echarts'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { colorArray as chartColors } from './config'
import { EssEnergyGrowthTrendChartData } from '../types'


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data?: EssEnergyGrowthTrendChartData
}

const chart = ref()


watch(
  () => props.data,
  (newData: EssEnergyGrowthTrendChartData | undefined) => {
    if (chart.value && newData) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      console.log()
      if (chartInstance) {
        chartInstance.setOption({
          xAxis: [
            {
              data: newData.xAxisData || [],
            },
          ],
          series: chartOption.value.series.map((series, index) => {
            return {
              ...series,
              name: newData.seriesData ? newData.seriesData[index].name : series.name,
              data: newData.seriesData ? newData.seriesData[index].data : [],
            }
          }),
        })
      }
    }
  },
  { immediate: true, deep: true },
)

onMounted(() => {
  window.addEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
onUnmounted(() => {
  // 清理事件监听
  window.removeEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})

// ECharts 的配置项
const chartOption = computed(() => {
  return {
    // 背景色
    // backgroundColor: '#2c343c',

    // 提示框组件
    color: chartColors,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },
    },

    // 图例组件 (此图中没有，可以不配置或隐藏)
    // legend: {
    //   data: ['系列一', '系列二'],
    //   textStyle: {
    //     color: '#ccc'
    //   }
    // },

    // 网格配置，控制图表的位置和大小
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true, // 防止标签溢出
    },

    // X 轴配置
    xAxis: [
      {
        type: 'category',
        boundaryGap: false, // 坐标轴两边不留白
        data: [], // 示例数据类别
        axisLabel: {
          show: false, // 不显示 x 轴标签
        },
        axisTick: {
          show: false, // 不显示刻度
        },
        axisLine: {
          show: false, // 不显示轴线
        },
      },
    ],

    // Y 轴配置
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          color: '#ccc', // y 轴标签颜色
        },
        axisLine: {
          show: false, // 不显示轴线
        },
        axisTick: {
          show: false, // 不显示刻度
        },
        splitLine: {
          // 网格线
          lineStyle: {
            color: '#3e4a57', // 网格线颜色
            type: 'dashed',
          },
        },
      },
    ],

    // 系列列表，每个系列通过 type 决定自己的图表类型
    series: [
      {
        name: '充电量',
        type: 'line',
        smooth: true, // 平滑曲线
        lineStyle: {
          width: 2,
          color: '#07c1c1', // 青色线条
        },
        showSymbol: false, // 不显示数据点
        areaStyle: {
          // 区域渐变填充
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(7, 193, 193, 0.4)', // 渐变起始色
            },
            {
              offset: 1,
              color: 'rgba(7, 193, 193, 0)', // 渐变结束色
            },
          ]),
        },
        // 这里的数据是根据图片中的曲线形状模拟的
        data: [],
      },
      {
        name: '放电量',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 2,
          color: '#ffa600', // 橙色线条
        },
        showSymbol: false,
        areaStyle: {
          // 区域渐变填充
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(255, 166, 0, 0.4)',
            },
            {
              offset: 1,
              color: 'rgba(255, 166, 0, 0)',
            },
          ]),
        },
        // 这里的数据是根据图片中的曲线形状模拟的
        data: [],
      },
      {
        name: '发电量',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 2,
          color: '#5e4eff', // 橙色线条
        },
        showSymbol: false,
        areaStyle: {
          // 区域渐变填充
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(94,78,255, 0.4)',
            },
            {
              offset: 1,
              color: 'rgba(255, 166, 0, 0)',
            },
          ]),
        },
        // 这里的数据是根据图片中的曲线形状模拟的
        data: [],
      },
    ],
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"100%","height":"100%"},
    ref_key: "chart",
    ref: chart
  }, null, 512))
}
}

})